import React from 'react';
import { CachedImage } from './CachedImage';

interface ConnectAccountGateProps {
  agentTitle: string;
  agentImg?: string;
  isConnecting: boolean;
  onConnect: () => void;
  colors: any;
}

const ConnectAccountGate: React.FC<ConnectAccountGateProps> = ({
  agentTitle,
  agentImg,
  isConnecting,
  onConnect,
  colors,
}) => (
  <div style={{
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    gap: '20px',
    padding: '40px',
    maxWidth: '460px',
    margin: '0 auto',
  }}>
    {agentImg && (
      <div style={{
        width: '72px',
        height: '72px',
        borderRadius: '18px',
        overflow: 'hidden',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
      }}>
        <CachedImage
          src={agentImg}
          alt={`${agentTitle} icon`}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          fallback={<div style={{ width: '100%', height: '100%', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }} />}
        />
      </div>
    )}

    <h2 style={{
      fontSize: '22px',
      fontWeight: 700,
      color: colors.textPrimary,
      margin: 0,
    }}>
      Connect your account
    </h2>

    <p style={{
      fontSize: '15px',
      color: colors.textMuted,
      lineHeight: 1.6,
      margin: 0,
    }}>
      To use <strong style={{ color: colors.textSecondary || colors.textMuted }}>{agentTitle}</strong>,
      sign in with your own account. The assistant will act on your behalf and can
      only see and do what your permissions allow.
    </p>

    <button
      onClick={onConnect}
      disabled={isConnecting}
      style={{
        padding: '12px 28px',
        fontSize: '15px',
        fontWeight: 600,
        color: 'white',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        border: 'none',
        borderRadius: '12px',
        cursor: isConnecting ? 'default' : 'pointer',
        opacity: isConnecting ? 0.7 : 1,
        transition: 'opacity 0.2s ease',
      }}
    >
      {isConnecting ? 'Redirecting…' : 'Connect account'}
    </button>
  </div>
);

export default ConnectAccountGate;